var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: { id: "warningTimeout", role: "dialog" },
    },
    [
      _c("div", { staticClass: "modal-dialog" }, [
        _c("div", { staticClass: "modal-content first-modal-content" }, [
          _vm._m(0),
          _c("div", { staticClass: "modal-body" }, [
            _c("div", { staticClass: "sub-header pt-11" }, [
              _vm._m(1),
              _c("span", {}, [
                _c("strong", [_vm._v("  " + _vm._s(_vm.gettime) + " seconds")]),
                _vm._v(" due to inactivity."),
              ]),
            ]),
            _c("div", { staticClass: "sub-header pt-35" }, [
              _vm._v("Do you want to stay logged in?"),
            ]),
          ]),
          _c("div", { staticClass: "modal-footer warningTimeout-bgcolor" }, [
            _c(
              "div",
              { staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12 mt-10" },
              [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-block emergo-white-button",
                    on: { click: _vm.loadLogOut },
                  },
                  [_vm._v("Log Out")]
                ),
              ]
            ),
            _c(
              "div",
              { staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12 mt-10" },
              [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-block emergo-green-button",
                    attrs: {
                      "data-dismiss": "modal",
                      "data-toggle": "tab",
                      "data-target": "#warningTimeout",
                    },
                    on: { click: _vm.loadAgain },
                  },
                  [_vm._v(" Stay Connected ")]
                ),
              ]
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header warningTimeout-bgcolor" }, [
      _c("div", { staticClass: "modal-title" }, [
        _c("div", { staticClass: "title-text" }, [_vm._v("Session Timeout")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", [_vm._v("Your session is about to expire in "), _c("br")])
  },
]
render._withStripped = true

export { render, staticRenderFns }